<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" class="inline-form">
        <el-form-item label="机构编号">
          <el-input v-model="searchInfo.customerId" placeholder="请输入机构编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="searchLoading"></auth-button>
          <auth-button opt="export" :plain="true" @click.native="exportClick" label="导出" :loading="exportLoading"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 提取记录table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="searchLoading"
        :data="withdrawlist"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="customerId"
          label="机构编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="enterpriseTitle"
          label="机构名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="profitTotalIncome"
          label="历史分润合计"
          align="center">
        </el-table-column>
        <el-table-column
          prop="profitAlreadyPickMoney"
          label="已打款金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="stoppayrealmoney"
          label="止付金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="invoiceBalance"
          label="发票余额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="profitBalance"
          label="分润余额"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          align="center">
          <template slot-scope="scope">
            <auth-button opt="extract" type="text" label="提取分润" @click.native="profitExtract(scope.row)"></auth-button>
            <auth-button opt="extract_record" type="text" label="提取记录" @click.native="profitExtractRecord(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo" :size="paginations.pageSize"></pagination>
    <el-dialog
      v-if="profitDialogVisible"
      :visible.sync="profitDialogVisible"
      title="提取分润"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true">
      <div class="extract-amount">
        提取金额
        <el-input class="extract-amount-input" placeholder="请输入金额" v-model="extractAmount">
          <template slot="append">
            <div class="extract-all" @click="extractAmount = benefitBalance">全部提取</div>
          </template>
        </el-input>
      </div>
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" size="small" @click="extractClick" :loading="extractLoading">确认提取</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import pagination from '@/components/pagination'
import { listCustomerProfitStatistics, exportCustomerProfitStatistics, profitPickUp } from '@/api/settle'
export default {
  name: 'CustomerProfitExtract',
  components: {
    pagination
  },
  data () {
    return {
      searchLoading: false,
      exportLoading: false,
      extractLoading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 5
      },
      // 搜索表单信息
      searchInfo: {
        customerId: ''
      },
      exportForm: {
        moduleCode: 8,
        moduleName: '分润提取',
        menuName: '分润提取记录'
      },
      profitCustomerId: '',
      benefitBalance: 0,
      invoiceBalance: 0,
      profitDialogVisible: false,
      extractAmount: ''
    }
  },
  beforeDestroy () {},
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      this.getQueryAgentWithdrawOrder()
    },
    /**
     * 获取分润提取记录
     */
    getQueryAgentWithdrawOrder () {
      this.searchLoading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      listCustomerProfitStatistics(params).then(response => {
        this.searchLoading = false
        console.log('queryAgentWithdrawOrder response:', response)
        if (response.error_code === '0') {
          // const json = response.data
          this.withdrawlist = response.data
          this.paginations.count = response.total
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
          // this.$message({
          //   message: response.error_msg,
          //   type: 'success'
          // })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    exportClick (noReset) {
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      this.exportCustomerProfitStatistics()
    },
    exportCustomerProfitStatistics () {
      this.exportLoading = true
      const data = qs.stringify(Object.assign({}, this.searchInfo, this.exportForm))
      exportCustomerProfitStatistics(data).then(res => {
        this.exportLoading = false
        if (parseInt(res.result_cde) === 0) {
          this.exportLoading = false
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.exportLoading = false
          this.$message({
            message: res.result_msg,
            type: 'error'
          })
        }
      })
    },
    profitExtract (row) {
      this.profitCustomerId = row.customerId
      this.benefitBalance = row.profitBalance
      this.invoiceBalance = row.invoiceBalance
      this.profitDialogVisible = true
    },
    profitExtractRecord (row) {
      this.$router.push({ path: '/SettleAccounts/Profit/CustomerProfitExtractRecordMenu', query: { customerId: row.customerId } })
    },
    extractClick () {
      if (parseFloat(this.extractAmount) > parseFloat(this.benefitBalance) || parseFloat(this.extractAmount) > parseFloat(this.invoiceBalance)) {
        this.$message({
          message: '提取金额不能超过发票余额和分润余额',
          type: 'warning'
        })
        return
      }
      this.extractLoading = true
      profitPickUp({
        agentId: this.profitCustomerId,
        amount: this.extractAmount
      }).then(response => {
        this.extractLoading = false
        console.log('pickUpProfit response:', response)
        if (response.error_code === '0') {
          this.extractAmount = ''
          this.profitDialogVisible = false
          this.$message({
            message: '提取成功',
            type: 'success'
          })
          this.searchClick()
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.searchClick()
  }
}
</script>

<style lang="scss" scoped>
  @mixin flex-horizontal {
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.extract-amount {
  @include flex-horizontal;
  justify-content: center;
  margin: 30px 0;
  .extract-amount-input {
    margin-left: 15px;
    width: 300px;
    .extract-all {
      cursor: pointer;
    }
  }
}
</style>
